export enum BannerType {
    INFO = "info",
    WARNING = "warning",
    ERROR = "error",
    SUCCESS = "success",
}

export type BannerCallback = () => void | Promise<void>;

type BannerDataProps = {
    id: string;
    icon: string;
    title: string;
    mainText: string;
    callToActionText?: string;
    callToActionCallback?: BannerCallback;
    type?: BannerType;
    dismissible?: boolean;
    linkUrl?: string;
    priority?: number;
};

export default class BannerData {
    id: string;

    icon: string;

    title: string;

    mainText: string;

    callToActionText?: string;

    callToActionCallback?: BannerCallback;

    type?: BannerType;

    dismissible?: boolean;

    linkUrl?: string;

    priority?: number;

    constructor({
        id,
        icon,
        title,
        mainText,
        callToActionText,
        callToActionCallback,
        type,
        dismissible,
        linkUrl,
        priority,
    }: BannerDataProps) {
        this.id = id;
        this.icon = icon;
        this.title = title;
        this.mainText = mainText;
        this.callToActionText = callToActionText;
        this.callToActionCallback = callToActionCallback;
        this.type = type;
        this.dismissible = dismissible;
        this.linkUrl = linkUrl;
        this.priority = priority;
    }
}
